module.exports = __webpack_public_path__ + "img/fanfestlive.a98d5292.jpg";